import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'featured';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group block bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
      >
        <div className="relative h-72 md:h-80 overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            title={`${article.title} - 52吃瓜网`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <span className="inline-block px-3 py-1 text-xs font-semibold bg-accent-500 text-foreground-950 rounded-full mb-3 whitespace-nowrap">
              {article.category}
            </span>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 leading-snug line-clamp-2">
              {article.title}
            </h3>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
    >
      <div className="relative h-52 md:h-56 overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          title={`${article.title} - 52吃瓜网`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-3 py-1 text-xs font-semibold bg-accent-500 text-foreground-950 rounded-full whitespace-nowrap">
            {article.category}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors mb-3">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.readCount > 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}阅读
          </span>
        </div>
      </div>
    </Link>
  );
}